export default "__VITE_ASSET__BSwt4GNB__"